import { render, staticRenderFns } from "./NPAssetPowerUp.vue?vue&type=template&id=3ca4b64c&scoped=true&"
import script from "./NPAssetPowerUp.vue?vue&type=script&lang=js&"
export * from "./NPAssetPowerUp.vue?vue&type=script&lang=js&"
import style0 from "./NPAssetPowerUp.vue?vue&type=style&index=0&id=3ca4b64c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca4b64c",
  null
  
)

export default component.exports